import type { ComponentProps } from 'react'
import _PriceRowPrice from './_PriceRowPrice'

type InheritedBaseProps = Pick<ComponentProps<typeof _PriceRowPrice>, 'discountPercentage' | 'discountType' | 'price' | 'priceFormat' | 'priceStyle' | 'saleUnit' | 'signDisplay' | 'size'>

interface Props extends Utils.PropsWithDataAttributes, InheritedBaseProps {
}

/**
 * Displays a formatted price with a trailing sale unit.
 */
function PriceRowPrice(props: Props) {
  return <_PriceRowPrice {...props} />
}

export default PriceRowPrice
